import { connectHook } from '../../connect-hook';
import { Autocomplete, type AutocompleteProps } from './autocomplete';
import { type AutocompleteHookProps, useAutocomplete } from './autocomplete-hook';

export default connectHook<AutocompleteHookProps, AutocompleteProps>(Autocomplete, useAutocomplete);
